<template>
  <div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <p>
              For issues, general questions or feedback, please contact <a href="mailto:support-1@casemgrsolutions.com">support-1@casemgrsolutions.com</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
  export default {
  }
</script>



// WEBPACK FOOTER //
// Contact.vue?2a133484